import { useMutation } from "@tanstack/react-query";
import { propertySelectionApi } from "libs/api";
import { useState } from "react";
import { useParams } from "router";
import { ValidationError } from "./constants";

export const usePaintedDoorHandler = () => {
    const { lang } = useParams("/:lang/list-my-property/get-started");

    const { mutate, isLoading, isError, isSuccess } = useMutation<unknown, unknown, string>((platform) =>
        propertySelectionApi.submitImportAnotherPlatform(lang, platform),
    );

    const [validationError, setValidationError] = useState<ValidationError | null>(null);

    const handleSubmit = (choice: string, others: string) => {
        setValidationError(null);

        if (choice === undefined) {
            setValidationError(ValidationError.MissingChoice);
        } else if (choice === "Others" && others === "") {
            setValidationError(ValidationError.MissingOthers);
        } else {
            mutate(choice === "Others" ? others : choice);
        }
    };

    return {
        handleSubmit,
        loading: isLoading,
        validationError,
        completed: isError || isSuccess,
    };
};
